import React from 'react';
import { GraphicCardGeneral } from './styles';

export default function GraphicCard({ title, quantity, icon: Component }) {
  return (
    <GraphicCardGeneral>
      <div>
        <h1>Total de {title}</h1>
        <h2>{quantity}</h2>
        <p>Pedidos</p>
      </div>
      {Component && <Component />}
    </GraphicCardGeneral>
  );
}
